import individual from "../icons/individual.svg";

const ServiceData = [
  {
    title: "Enterprise Service",
    list: [
      "Web Development",
      "App Development",
      "Graphic Design",
      "Content Writing",
    ],
    link: "/enterprise",
    icon: individual,
  },
  {
    title: "Individual Service",
    list: [
      "Personal websites",
      "Portfolio websites",
      "Event websites",
      "Many More",
    ],
    link: "/individual",
    icon: individual,
  },
];

export { ServiceData };
